// k2o — ingredientes desplegables y botones que abren el formulario de Releasit.
(function () {
  function iniciar() {
    // Ingredientes: tarjeta que muestra/oculta su descripción
    document.querySelectorAll('[data-pc-ing]').forEach(function (tarjeta) {
      var cab = tarjeta.querySelector('[data-pc-ing-cab]');
      var desc = tarjeta.querySelector('[data-pc-ing-desc]');
      if (!cab || !desc) return;
      cab.addEventListener('click', function () {
        var abrir = desc.hasAttribute('hidden');
        if (abrir) desc.removeAttribute('hidden'); else desc.setAttribute('hidden', '');
        tarjeta.setAttribute('data-abierto', abrir ? 'true' : 'false');
        cab.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      });
    });

    // Botones dorados: abren el formulario de pedido de Releasit (si no está, bajan a la compra)
    document.querySelectorAll('[data-pc-releasit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var candidatos = [].slice.call(document.querySelectorAll('button#rsi_buy_now_button'));
        var visible = candidatos.filter(function (b) { var r = b.getBoundingClientRect(); return r.width > 0 && r.height > 0; })[0];
        if (visible) { visible.click(); return; }
        var destino = document.querySelector('.pc-compra');
        if (destino) {
          var y = destino.getBoundingClientRect().top + window.pageYOffset - 12;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
